import { AdvancedFormReturnType } from 'helpers/form/useAdvancedForm';
import { Controller } from 'react-hook-form';
import { VariableModalSelector } from '../variableModalSelector/VariableModalSelector';

export type RadioButtonOption = {
  text: string;
};

type VariableTypeSelectorProps = {
  form?: AdvancedFormReturnType<any, object>;
  onChange?: (selectedOption: RadioButtonOption) => void;
  defaultValue?: RadioButtonOption;
  options: RadioButtonOption[];
  name: string;
  disabled?: boolean;
};

export const VariableTypeSelector: React.FC<VariableTypeSelectorProps> = (
  props,
) => {
  return (
    <Controller
      name={props.name}
      control={props.form?.control}
      render={({ field: { onChange, value } }) => (
        <VariableModalSelector
          onChange={onChange}
          value={value}
          defaultValue={props.defaultValue}
          options={props.options}
          disabled={props.disabled}
        />
      )}
    />
  );
};
